import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { LucideAngularModule } from 'lucide-angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { SidebarComponent } from './core/components/sidebar/sidebar.component';
import { NavbarComponent } from './core/components/navbar/navbar.component';
import { BreadcrumbComponent } from './core/components/breadcrumb/breadcrumb.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { ToastComponent } from './modules/shared/components/toast/toast.component';
import { ConfirmDialogComponent } from './modules/shared/components/confirm-dialog/confirm-dialog.component';

import { JwtInterceptor } from './core/interceptors/jwt.interceptor';

import {
  LayoutDashboard, Building2, Briefcase, Building, Users,
  UserCircle, Clock, CalendarOff, ClipboardList, BarChart3,
  Database, Plus, ChevronDown, ChevronLeft, ChevronRight,
  ChevronUp, Home, Bell, LogOut, Menu, X, Search, Filter, CheckCircle,
  XCircle, Download, Pencil, Trash2, Eye, User, Settings,
  Loader2, AlertCircle, Check, Info, TriangleAlert, LogIn, UserCheck, UserX,
  RefreshCw, Printer, ArrowUpDown, MoreHorizontal, Inbox,
  ArrowLeft, ArrowRight, FileCheck, AlarmClock, Receipt, FileText,
  Mail, Phone, MapPin, CalendarDays, Upload, UserPlus, FileX, FileQuestionMark, Minus, Paperclip, CirclePlus
} from 'lucide-angular';

@NgModule({
  declarations: [
    AppComponent,
    SidebarComponent,
    NavbarComponent,
    BreadcrumbComponent,
    AuthLayoutComponent,
    MainLayoutComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    RouterModule,
    AppRoutingModule,
    ToastComponent,
    ConfirmDialogComponent,
    LucideAngularModule.pick({
      LayoutDashboard, Building2, Briefcase, Building, Users,
      UserCircle, Clock, CalendarOff, ClipboardList, BarChart3,
      Database, Plus, ChevronDown, ChevronLeft, ChevronRight,
      ChevronUp, Home, Bell, LogOut, Menu, X, Search, Filter, CheckCircle,
      XCircle, Download, Pencil, Trash2, Eye, User, Settings,
      Loader2, AlertCircle, Check, Info, TriangleAlert, LogIn, UserCheck, UserX,
      RefreshCw, Printer, ArrowUpDown, MoreHorizontal, Inbox,
      ArrowLeft, ArrowRight, FileCheck, AlarmClock, Receipt, FileText,
      Mail, Phone, MapPin, CalendarDays, Upload, UserPlus, FileX, FileQuestionMark, Minus, Paperclip, CirclePlus
    })
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
